import React from 'react'

import { Route } from 'wouter'
import type { RoutesInfo } from 'routes/types'

const PrivateConsignedCancellation = React.lazy(() => import('../pages/cancellation'))
const PrivateConsignedCancellationReceipt = React.lazy(() => import('../pages/cancellationReceipt'))
const PrivateConsignedCancellationRevision = React.lazy(
  () => import('../pages/cancellationRevision'),
)

export const PrivateConsignedRoutesInfo: Record<string, RoutesInfo> = {
  cancelPrivateConsigned: { path: '/privateConsigned/cancellation' },
  revisionPrivateConsigned: { path: '/privateConsigned/cancellation/revision' },
  receiptPrivateConsigned: { path: '/privateConsigned/cancellation/receipt' },
}

export const PrivateConsignedModule: React.FC = () => (
  <>
    <Route
      path={PrivateConsignedRoutesInfo.cancelPrivateConsigned.path}
      component={PrivateConsignedCancellation}
    />
    <Route
      path={PrivateConsignedRoutesInfo.revisionPrivateConsigned.path}
      component={PrivateConsignedCancellationRevision}
    />
    <Route
      path={PrivateConsignedRoutesInfo.receiptPrivateConsigned.path}
      component={PrivateConsignedCancellationReceipt}
    />
  </>
)
